import {isNew} from 'services/utils/editForm'
import {Page, PageContent} from 'components/Page'
import {FormProvider} from 'react-hook-form'
import {useI18n} from 'store/Store'
import {useParams} from 'react-router-dom'
import FormTitle from 'components/Page/Form/FormTitle'
import usePublicationFolderForm from 'logic/Forms/usePublicationFolderForm'
import PublicationFolderForm from 'components/Page/PublicationFolder/PublicationFolderForm'

const PublicationFolder = () => {
    const {i18n} = useI18n()
    const {publicationFolderId} = useParams()
    const {form, submit, publicationFolder} =
        usePublicationFolderForm(publicationFolderId)

    return (
        <Page>
            <PageContent>
                <FormTitle
                    itemId={publicationFolderId}
                    itemLabel={i18n.t(`tables.publicationFolder`)}
                    submit={submit}
                />
                <FormProvider {...form}>
                    <PublicationFolderForm
                        publicationFolder={publicationFolder}
                        isNew={isNew(publicationFolderId)}
                    />
                </FormProvider>
            </PageContent>
        </Page>
    )
}

export default PublicationFolder
